import React from "react";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { useTranslation } from "react-i18next";
import { CircleFlag } from "react-circle-flags";

export function LanguageSelector({ className, style }) {
  const { i18n } = useTranslation();

  // Normalize to base language code (e.g., "en" from "en-GB")
  const current = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];

  const languages = [
    { code: "en", label: "English (UK)", flagCode: "gb", title: "English (UK)" },
    { code: "cy", label: "Cymraeg", flagCode: "gb-wls", title: "Cymraeg (Welsh)" },
  ];

  const currentLang = languages.find(l => l.code === current) || languages[0];

  const handleChange = (code) => {
    if (code !== current) {
      i18n.changeLanguage(code);
    }
  };

  const FlagIcon = ({ code }) => (
    <span className="tw-inline-flex tw-items-center tw-mr-2">
      <CircleFlag countryCode={code} height="18" />
    </span>
  );

  return (
    <UncontrolledDropdown className={className} style={style}>
      <DropdownToggle color="light" caret aria-label={`Language: ${currentLang.label}`} title={currentLang.title}>
        <FlagIcon code={currentLang.flagCode} />
        {currentLang.label}
      </DropdownToggle>
      <DropdownMenu right>
        {languages.map(lang => (
          <DropdownItem
            key={lang.code}
            active={lang.code === current}
            onClick={() => handleChange(lang.code)}
            aria-label={lang.label}
            title={lang.title}
          >
            <FlagIcon code={lang.flagCode} />
            {lang.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}